import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { authGuard } from './guards'
import LandingView from '@/views/LandingView.vue'
import LoginView from '@/views/LoginView.vue'
import DashboardView from '@/views/DashboardView.vue'
import GamesView from '@/views/GamesView.vue'
import AdminView from '@/views/AdminView.vue'
import StatsView from '@/views/StatsView.vue'
import PlayerView from '@/views/PlayerView.vue'
import ProbabilisticBoxscoreView from '@/views/ProbabilisticBoxscoreView.vue'
import SimulateView from '@/views/SimulateView.vue'
const OddsView = () => import('@/views/OddsView.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: LandingView,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { requiresAuth: false, guestOnly: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/games',
    name: 'games',
    component: GamesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/odds',
    name: 'odds',
    component: OddsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: { requiresAuth: true, requiresSuperuser: true }
  },
  {
    path: '/stats',
    name: 'stats',
    component: StatsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/players/:id',
    name: 'player',
    component: PlayerView,
    meta: { requiresAuth: true }
  },
  {
    path: '/boxscore-demo',
    name: 'ProbabilisticBoxscore',
    component: ProbabilisticBoxscoreView,
    meta: { requiresAuth: false }
  },
  {
    path: '/simulate/:id',
    name: 'simulate',
    component: SimulateView,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Initialize auth before first navigation
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  // Initialize auth state from localStorage on first navigation
  if (!from.name) {
    authStore.initializeAuth()
  }

  authGuard(to, from, next)
})

export default router
